import React from "react";
import {
  AttendaceTable,
  AttendaceTbody,
  AttendaceTd,
  AttendaceTH,
  AttendaceThead,
  AttendaceTr,
  AttendanceBx,
  AttendanceBxWraper,
  AttendanceTxtBx,
  CardBoxshadow,
  ContentBody,
  ContentHeading,
  ContentLayout,
  PunchLi,
  PunchUl,
  PunchUlScroll,
  TableResponsive,
  TimerBox,
} from "../../style";
import {
  Col,
  Button,
  InputField,
  Row,
  Typography,
  Icon,
  Avatar,
  Flex,
  Box,
  Gap,
  Tooltip,
  Dialog,
  SelectField,
} from "../../../ppui";
import {
  TbBriefcase,
  TbChecks,
  TbFileExport,
  TbSearch,
  TbUserCheck,
  TbUsers,
  TbUserX,
  TbX,
} from "react-icons/tb";
import { MdOutlineWatchLater } from "react-icons/md";

const TimeTracking = () => {
  const [AttendanceInfo, setAttendanceInfo] = React.useState(false);
  const AttendanceInfoModalOpen = () => setAttendanceInfo(true);
  const AttendanceInfoModalClose = () => setAttendanceInfo(false);

  const [LeaveInfo, setLeaveInfo] = React.useState(false);
  const LeaveInfoModalOpen = () => setLeaveInfo(true);
  const LeaveInfoModalClose = () => setLeaveInfo(false);
  return (
    <>
      <ContentLayout>
        <ContentHeading>
          <Typography variant="h5" mb="0">
            Biometric Data
          </Typography>
        </ContentHeading>

        <Row>
          <Col md={3}>
            <CardBoxshadow>
              <Flex alignItem="center" gap={20}>
                <Avatar
                  size="sm"
                  color="primary"
                  shape="square"
                  icon={<TbUsers />}
                />
                <Box>
                  <Typography variant="body1" strong mb="0">
                    43
                  </Typography>
                  <Typography variant="body2" mb="0">
                    Total Employee
                  </Typography>
                </Box>
              </Flex>
            </CardBoxshadow>
          </Col>
          <Col md={3}>
            <CardBoxshadow>
              <Flex alignItem="center" gap={20}>
                <Avatar
                  size="sm"
                  color="danger"
                  shape="square"
                  icon={<TbUserX />}
                />
                <Box>
                  <Typography variant="body1" strong mb="0">
                    6
                  </Typography>
                  <Typography variant="body2" mb="0">
                    Absent Employee
                  </Typography>
                </Box>
              </Flex>
            </CardBoxshadow>
          </Col>

          <Col md={3}>
            <CardBoxshadow>
              <Flex alignItem="center" gap={20}>
                <Avatar
                  size="sm"
                  color="success"
                  shape="square"
                  icon={<TbUserCheck />}
                />
                <Box>
                  <Typography variant="body1" strong mb="0">
                    32
                  </Typography>
                  <Typography variant="body2" mb="0">
                    Present Employee
                  </Typography>
                </Box>
              </Flex>
            </CardBoxshadow>
          </Col>

          <Col md={3}>
            <CardBoxshadow>
              <Flex alignItem="center" gap={20}>
                <Avatar
                  size="sm"
                  color="secondary"
                  shape="square"
                  icon={<TbBriefcase />}
                />
                <Box>
                  <Typography variant="body1" strong mb="0">
                    25
                  </Typography>
                  <Typography variant="body2" mb="0">
                    Working Days
                  </Typography>
                </Box>
              </Flex>
            </CardBoxshadow>
          </Col>
        </Row>
        <Gap height={30} />
        <ContentBody>
          <Row rowGap px={20} py={20}>
            <Col sm={12} md={4} lg={"auto"}>
              <InputField
                fullWidth
                placeholder="Search"
                type="search"
                suffix={<TbSearch />}
              />
            </Col>

            <Col sm={12} md={4} lg={2}>
              <InputField fullWidth placeholder="Select Month" type="week" />
            </Col>

            <Col sm={12} md={4} lg={"auto"} ml={"auto"}>
              <Button
                fullWidth
                color="primary"
                variant="contained"
                onClick={() => {}}
              >
                Generate Attendance
              </Button>
            </Col>

            <Col sm={12} md={4} lg={"auto"}>
              <Button
                fullWidth
                color="primary"
                onClick={() => {}}
                variant="outlined"
                icon={<TbFileExport />}
              >
                Export
              </Button>
            </Col>
          </Row>

          <TableResponsive>
            <AttendaceTable>
              <AttendaceThead>
                <AttendaceTr>
                  <AttendaceTH>Employee</AttendaceTH>
                  <AttendaceTH>1</AttendaceTH>
                  <AttendaceTH>2</AttendaceTH>
                  <AttendaceTH>3</AttendaceTH>
                  <AttendaceTH>4</AttendaceTH>
                  <AttendaceTH>5</AttendaceTH>
                  <AttendaceTH>6</AttendaceTH>
                  <AttendaceTH>7</AttendaceTH>
                  <AttendaceTH>8</AttendaceTH>
                  <AttendaceTH>9</AttendaceTH>
                  <AttendaceTH>10</AttendaceTH>
                  <AttendaceTH>11</AttendaceTH>
                  <AttendaceTH>12</AttendaceTH>
                  <AttendaceTH>13</AttendaceTH>
                  <AttendaceTH>14</AttendaceTH>
                  <AttendaceTH>15</AttendaceTH>
                  <AttendaceTH>16</AttendaceTH>
                  <AttendaceTH>17</AttendaceTH>
                  <AttendaceTH>18</AttendaceTH>
                  <AttendaceTH>19</AttendaceTH>
                  <AttendaceTH>20</AttendaceTH>
                  <AttendaceTH>21</AttendaceTH>
                  <AttendaceTH>22</AttendaceTH>
                  <AttendaceTH>23</AttendaceTH>
                  <AttendaceTH>24</AttendaceTH>
                  <AttendaceTH>25</AttendaceTH>
                  <AttendaceTH>26</AttendaceTH>
                  <AttendaceTH>27</AttendaceTH>
                  <AttendaceTH>28</AttendaceTH>
                  <AttendaceTH>29</AttendaceTH>
                  <AttendaceTH>30</AttendaceTH>
                  <AttendaceTH>31</AttendaceTH>
                </AttendaceTr>
              </AttendaceThead>
              <AttendaceTbody>
                <AttendaceTr>
                  <AttendaceTH>
                    <Flex gap={"6"} alignItem={"center"}>
                      <Avatar initials="JD" size="sm" color="secondary" />
                      <Box>
                        <Typography variant="body1" mb="0" color="secondary">
                          John Doe
                        </Typography>
                        <Typography
                          color="default"
                          variant="body2"
                          colorVariant="light"
                          mb="0"
                        >
                          #E1035
                        </Typography>
                      </Box>
                    </Flex>
                  </AttendaceTH>
                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Medical Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Privilege Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>
                </AttendaceTr>

                <AttendaceTr>
                  <AttendaceTH>
                    <Flex gap={"6"} alignItem={"center"}>
                      <Avatar initials="JD" size="sm" color="secondary" />
                      <Box>
                        <Typography variant="body1" mb="0" color="secondary">
                          John Doe
                        </Typography>
                        <Typography
                          color="default"
                          variant="body2"
                          colorVariant="light"
                          mb="0"
                        >
                          #E1035
                        </Typography>
                      </Box>
                    </Flex>
                  </AttendaceTH>
                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Medical Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Privilege Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>
                </AttendaceTr>

                <AttendaceTr>
                  <AttendaceTH>
                    <Flex gap={"6"} alignItem={"center"}>
                      <Avatar initials="JD" size="sm" color="secondary" />
                      <Box>
                        <Typography variant="body1" mb="0" color="secondary">
                          John Doe
                        </Typography>
                        <Typography
                          color="default"
                          variant="body2"
                          colorVariant="light"
                          mb="0"
                        >
                          #E1035
                        </Typography>
                      </Box>
                    </Flex>
                  </AttendaceTH>
                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Medical Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Privilege Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>
                </AttendaceTr>

                <AttendaceTr>
                  <AttendaceTH>
                    <Flex gap={"6"} alignItem={"center"}>
                      <Avatar initials="JD" size="sm" color="secondary" />
                      <Box>
                        <Typography variant="body1" mb="0" color="secondary">
                          John Doe
                        </Typography>
                        <Typography
                          color="default"
                          variant="body2"
                          colorVariant="light"
                          mb="0"
                        >
                          #E1035
                        </Typography>
                      </Box>
                    </Flex>
                  </AttendaceTH>
                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Medical Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Privilege Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>
                </AttendaceTr>

                <AttendaceTr>
                  <AttendaceTH>
                    <Flex gap={"6"} alignItem={"center"}>
                      <Avatar initials="JD" size="sm" color="secondary" />
                      <Box>
                        <Typography variant="body1" mb="0" color="secondary">
                          John Doe
                        </Typography>
                        <Typography
                          color="default"
                          variant="body2"
                          colorVariant="light"
                          mb="0"
                        >
                          #E1035
                        </Typography>
                      </Box>
                    </Flex>
                  </AttendaceTH>
                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Medical Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Privilege Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title="Sick Leave"
                      position="top"
                      size="md"
                      color="danger"
                      onClick={LeaveInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" size={"md"}>
                        {<TbX />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>

                  <AttendaceTd>
                    <Tooltip
                      title={
                        <>
                          <Box>Login 09:30AM</Box>
                          <Box>Logout 06:30PM</Box>
                        </>
                      }
                      position="top"
                      size="md"
                      color="success"
                      onClick={AttendanceInfoModalOpen}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="success" size={"md"}>
                        {<TbChecks />}
                      </Icon>
                    </Tooltip>
                  </AttendaceTd>
                </AttendaceTr>
          
              </AttendaceTbody>
            </AttendaceTable>
          </TableResponsive>
        </ContentBody>
      </ContentLayout>

      {/* Attendance-Modal-Info */}
      <Dialog
        title="Attendance Info"
        closeButton={true}
        fullWidth
        maxWidth="lg"
        open={AttendanceInfo}
        onClose={AttendanceInfoModalClose}
        action={false}
        bodyScroll={true}
        separator
      >
        <AttendanceBxWraper>
          <Row>
            <Col sm={6}>
              <AttendanceBx>
                <Flex alignItem="center" gap={"10"} mb={20}>
                  <Typography m="0" variant="h5" strong color="primary">
                    Timesheet
                  </Typography>
                  <Typography m="0" variant="body1">
                    26 Nov 2024{" "}
                  </Typography>
                </Flex>

                <AttendanceTxtBx>
                  <Typography py={2} px={4} m="0" variant="h4">
                    Punch In at
                  </Typography>
                  <Typography m="0" variant="body1">
                    Tue, 26 Nov 2024 09.30 AM{" "}
                  </Typography>
                </AttendanceTxtBx>
                <Gap height={20} />
                <TimerBox>
                  <Typography m="0" variant="h5" colorVariant="dark">
                    11.30 hrs
                  </Typography>
                </TimerBox>
                <Gap height={20} />
                <Row rowGap>
                  <Col sm={12}>
                    <AttendanceTxtBx>
                      <Typography
                        py={2}
                        px={4}
                        m="0"
                        variant="h6"
                        colorVariant="dark"
                      >
                        Punch Out At
                      </Typography>
                      <Typography m="0" variant="body1">
                        Tue, 26 Nov 2024 06.30 PM{" "}
                      </Typography>
                    </AttendanceTxtBx>
                  </Col>
                  <Col sm={6}>
                    <AttendanceTxtBx>
                      <Typography
                        py={2}
                        px={4}
                        m="0"
                        variant="h6"
                        colorVariant="dark"
                        align="center"
                      >
                        Break
                      </Typography>
                      <Typography strong m="0" variant="body1" align="center">
                        1.30hrs
                      </Typography>
                    </AttendanceTxtBx>
                  </Col>
                  <Col sm={6}>
                    {" "}
                    <AttendanceTxtBx>
                      <Typography
                        py={2}
                        px={4}
                        m="0"
                        variant="h6"
                        colorVariant="dark"
                        align="center"
                      >
                        Overtime
                      </Typography>
                      <Typography strong m="0" variant="body1" align="center">
                        2 hrs
                      </Typography>
                    </AttendanceTxtBx>
                  </Col>
                </Row>
              </AttendanceBx>
            </Col>
            <Col sm={6}>
              <AttendanceBx>
                <Typography mb={20} variant="h5" strong color="primary">
                  Activity
                </Typography>

                <PunchUlScroll>
                  <PunchUl>
                    <PunchLi>
                      <Typography
                        py={2}
                        px={4}
                        m="0"
                        variant="h5"
                        colorVariant="dark"
                      >
                        Punch In
                      </Typography>

                      <Flex alignItem="center">
                        <Icon color="default" size={"lg"}>
                          {<MdOutlineWatchLater />}
                        </Icon>
                        <Typography m="0" variant="h6">
                          10.00 AM.
                        </Typography>
                      </Flex>
                    </PunchLi>
                    <PunchLi>
                      <Typography
                        py={2}
                        px={4}
                        m="0"
                        variant="h5"
                        colorVariant="dark"
                      >
                        Punch In
                      </Typography>

                      <Flex alignItem="center">
                        <Icon color="default" size={"lg"}>
                          {<MdOutlineWatchLater />}
                        </Icon>
                        <Typography m="0" variant="h6">
                          11.00 AM.
                        </Typography>
                      </Flex>
                    </PunchLi>
                    <PunchLi>
                      <Typography
                        py={2}
                        px={4}
                        m="0"
                        variant="h5"
                        colorVariant="dark"
                      >
                        Punch In
                      </Typography>

                      <Flex alignItem="center">
                        <Icon color="default" size={"lg"}>
                          {<MdOutlineWatchLater />}
                        </Icon>
                        <Typography m="0" variant="h6">
                          12.00 AM.
                        </Typography>
                      </Flex>
                    </PunchLi>
                    <PunchLi>
                      <Typography
                        py={2}
                        px={4}
                        m="0"
                        variant="h5"
                        colorVariant="dark"
                      >
                        Punch Out
                      </Typography>

                      <Flex alignItem="center">
                        <Icon color="default" size={"lg"}>
                          {<MdOutlineWatchLater />}
                        </Icon>
                        <Typography m="0" variant="h6">
                          03.00 PM.
                        </Typography>
                      </Flex>
                    </PunchLi>
                  </PunchUl>
                </PunchUlScroll>
              </AttendanceBx>
            </Col>
          </Row>
        </AttendanceBxWraper>
      </Dialog>
      {/* Attendance-Modal-Info */}

      {/* Leave-Modal-Info */}
      <Dialog
        title="Leave Info"
        closeButton={true}
        fullWidth
        maxWidth="xs"
        open={LeaveInfo}
        onClose={LeaveInfoModalClose}
        separator
      >
          <Row rowGap>
            <Col sm={12}>
            <SelectField
              fullWidth
              required
              label="Leave Type"
              options={[
                { id: "option1", name: "Casual Leave" },
                { id: "option2", name: "Medical Leave" },
                { id: "option3", name: "Privilege Leave" },
                { id: "option4", name: "LOP" },
              ]}
              defaultValue="fixed"
              placeholder="Select Here..."
            />
            </Col>

            <Col sm={12}>
            <InputField
              required
              fullWidth
              label="Reason"
              type="text"
              placeholder="Type Here"
            />
            </Col>

          </Row>
      </Dialog>
      {/* Leave-Modal-Info */}
    </>
  );
};

export default TimeTracking;
